import * as React from "react";
import { useParams } from "react-router";
import PageContents from "../components/layouts/PageContents";
import ManageProjectDocumentsContainer from "../containers/ManageProjectDocumentsContainer";

const ProjectDocumentsPage: React.FC = () => {
    const [title, setTitle] = React.useState("Documents");
    const [subtitle, setSubtitle] = React.useState(
        "Please wait while we retrieve the documents list..."
    );
    const [isForbidden, setIsForbidden] = React.useState(false);
    const { projectId } = useParams();

    return (
        <PageContents
            title={title}
            subtitle={subtitle}
            isForbidden={isForbidden}
            variant="small"
        >
            <ManageProjectDocumentsContainer
                projectId={projectId!}
                setTitle={setTitle}
                setSubtitle={setSubtitle}
                setIsForbidden={setIsForbidden}
            />
        </PageContents>
    );
};

export default ProjectDocumentsPage;
